"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChartsToolbarPro = ChartsToolbarPro;
var _Toolbar = require("@mui/x-charts/Toolbar");
var React = _interopRequireWildcard(require("react"));
var _internals = require("@mui/x-charts/internals");
var _useChartProZoom = require("../internals/plugins/useChartProZoom");
var _ChartsToolbarZoomInButton = require("./internal/ChartsToolbarZoomInButton");
var _ChartsToolbarZoomOutButton = require("./internal/ChartsToolbarZoomOutButton");
var _jsxRuntime = require("react/jsx-runtime");
function ChartsToolbarPro() {
  const {
    store
  } = (0, _internals.useChartContext)();
  const isZoomEnabled = (0, _internals.useSelector)(store, _useChartProZoom.selectorChartZoomIsEnabled);
  const children = [];
  if (isZoomEnabled) {
    children.push(/*#__PURE__*/(0, _jsxRuntime.jsx)(_ChartsToolbarZoomInButton.ChartsToolbarZoomInButton, {}, "zoom-in"));
    children.push(/*#__PURE__*/(0, _jsxRuntime.jsx)(_ChartsToolbarZoomOutButton.ChartsToolbarZoomOutButton, {}, "zoom-out"));
  }
  if (children.length === 0) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Toolbar.Toolbar, {
    children: children
  });
}